<template>
  <!-- -->
  <div class="" style="height: 100%">
    <list-page>
      <search-condition :show-border="false" :show-shadow="false">
        <template #default>
          <el-input v-model="searchInfo.searchKey" placeholder="商品名称/分类名称" @keydown.enter="resetSearch" clearable>
            <template #prefix>关键字</template>
          </el-input>
          <el-select v-model="searchInfo.searchType" placeholder="授权方式" clearable>
            <template #prefix>授权方式</template>
            <el-option label="单个商品" :value="1"/>
            <el-option label="按分类" :value="2"/>
          </el-select>
          <employee-select v-model="searchInfo.employeeId" placeholder="请选择操作员">
            <template #prefix>操作员</template>
          </employee-select>
        </template>
        <template #option>
          <page-button el-type="primary" @click="resetSearch">查询</page-button>
          <page-button el-type="success" @click="toAddAuth">添加授权</page-button>
          <page-button el-type="warning" @click="toShowResult">查看结果</page-button>
        </template>
      </search-condition>
      <list-table background-color="#FFF">
        <yq-table :data="dataList" height="100%" stripe border page-name="productInfo" empty-text="授权全部数据">
          <yq-table-column label="授权方式" prop="authType" align="center">
            <template v-slot="{row}">
              <el-tag size="small" :type="row.authType === 2 ? 'warning' : 'primary'">{{row.authTypeName || (row.authType === 2 ? '按分类' : '单个商品')}}</el-tag>
            </template>
          </yq-table-column>
          <yq-table-column label="被授权职员" prop="staffName" width="120rem" :show-overflow-tooltip="true"/>
          <yq-table-column label="授权数据" prop="authDataName" min-width="180rem" :show-overflow-tooltip="true" >
            <template v-slot="{row}">{{row.productName || row.categoryName}}</template>
          </yq-table-column>
          <yq-table-column label="授权日期" width="140rem" :show-overflow-tooltip="true">
            <template v-slot="{row}">{{formatTime(row.createdTime)}}</template>
          </yq-table-column>
          <yq-table-column label="操作员" prop="grantorName" width="120rem" :show-overflow-tooltip="true"/>
          <yq-table-column label="操作" prop="options" :align="'center'" fixed="right" width="120rem" :show-overflow-tooltip="false">
            <template v-slot="{row}">
              <table-button-group label="更多操作">
                <table-button type="delete" el-type="danger" message="是否确认取消授权" @click="toDelete(row)">删除</table-button>
              </table-button-group>
            </template>
          </yq-table-column>
        </yq-table>
      </list-table>
      <form-page v-model:page-number="searchInfo.pageNumber" v-model:page-size="searchInfo.pageSize"
                 :total-count="searchInfo.totalCount" @onLoad="queryList" :show-border="false" :show-shadow="false"/>
    </list-page>
    <el-dialog v-model="showAdd" title="添加商品授权" dialog-width="1" :close-on-click-modal="false">
      <div class="grant-tip">
        <yq-icon name="element-ui_info" style="margin-right: 6px"/>
        单个商品授权：指定若干商品；按分类授权：指定商品分类，分类下所有商品将自动授权。
      </div>
      <form-items :data="currentData" ref="dialogData" :columns="1" label-width="2.4rem">
        <form-item label="授权方式" :required="true" name="authType" error-message="请选择授权方式">
          <el-select v-model="currentData.authType" placeholder="请选择授权方式" style="width: 100%">
            <el-option label="单个商品" :value="1"/>
            <el-option label="按分类" :value="2"/>
          </el-select>
        </form-item>
        <form-item label="被授权职员" :required="true" name="staffId" error-message="缺少被授权职员">
          <employee-select v-model="currentData.staffId" placeholder="请选择职员" :disabled="true"/>
        </form-item>
        <form-item label="授权商品" v-if="currentData.authType === 1" col-span="2" :show-block="true">
          <div class="grant-select-wrap">
            <product-select ref="productSelectTable" v-model="currentData.productListIds" :multi="true" :query-api="queryAllProductApi" @change="selectProduct2Current" style="width: 100%"/>
            <div class="grant-count" v-if="currentData.productList.length > 0">已选择 {{currentData.productList.length}} 个商品</div>
          </div>
        </form-item>
        <form-item label="授权分类" v-if="currentData.authType === 2" col-span="2" :show-block="true">
          <div class="grant-select-wrap">
            <el-tree-select v-model="currentData.categoryIdList" :data="productCategory" default-expand-all check-strictly
                            :render-after-expand="true" placeholder="请选择商品分类（可多选）" multiple clearable
                            :props="{children: 'children', label: 'dictName'}" node-key="dictCode" style="width: 100%"/>
            <div class="grant-count" v-if="currentData.categoryIdList.length > 0">已选择 {{currentData.categoryIdList.length}} 个分类</div>
          </div>
        </form-item>
      </form-items>
      <template #footer>
        <page-button @click="showAdd = false">取消</page-button>
        <page-button el-type="primary" @click="saveAuth">保存</page-button>
      </template>
    </el-dialog>
    <el-dialog v-model="authResultShow" title="商品授权最终结果" dialog-width="4">
      <dialog-table>
        <separator-page :show-border="true" :show-shadow="false">
          <template #category>
            <tree-dictionary v-model:dictionary-list="productCategoryAll" @clickCategory="clickCategory" :filter="true" placeholder="输入商品分类名称过滤" :disabled="true"/>
          </template>
          <template #default>
            <list-page>
              <search-condition :show-border="false" :show-shadow="false">
                <template #default>
                  <el-input v-model="authResultSearchInfo.searchKey" placeholder="名称/编码/拼音码" @keydown.enter="resultResetSearch">
                    <template #prefix>关键字</template>
                  </el-input>
                </template>
                <template #option>
                  <page-button type="read" el-type="primary" @click="resultResetSearch">查询</page-button>
                </template>
              </search-condition>
              <list-table :show-shadow="false">
                <yq-table :data="authResultList" height="100%" stripe border page-name="productInfo">
                  <yq-table-column label="图片" prop="image" width="60rem" align="center">
                    <template v-slot="{row}">
                      <image-show v-model="row.image" width="0.8rem" height="0.8rem"/>
                    </template>
                  </yq-table-column>
                  <yq-table-column label="商品名称" prop="productName" min-width="180rem" :show-overflow-tooltip="true" />
                  <yq-table-column label="基本单位" prop="unitIdBase" width="120rem" align="center">
                    <template v-slot="{row}">
                      <span v-for="u in unitList" :key="u.dictCode">
                        <el-tag v-if="u.dictCode === row.unitIdBase" type="success" size="small">{{u.dictName}}</el-tag>
                      </span>
                    </template>
                  </yq-table-column>
                  <yq-table-column label="授权方式" prop="authType" align="center">
                    <template v-slot="{row}">
                      <el-tag size="small" :type="row.authType === 2 ? 'warning' : 'primary'">{{row.authTypeName || (row.authType === 2 ? '按分类' : '单个商品')}}</el-tag>
                    </template>
                  </yq-table-column>
                  <yq-table-column label="授权日期" width="140rem" :show-overflow-tooltip="true">
                    <template v-slot="{row}">{{formatTime(row.createdTime)}}</template>
                  </yq-table-column>
                  <yq-table-column label="操作员" prop="grantorName" width="120rem" :show-overflow-tooltip="true"/>
                  <yq-table-column label="操作" prop="options" :align="'center'" fixed="right" width="120rem" :show-overflow-tooltip="false">
                    <template v-slot="{row}">
                      <table-button-group label="更多操作">
                        <table-button type="delete" el-type="danger" message="是否确认删除该商品" @click="toDeleteResult(row)">删除</table-button>
                      </table-button-group>
                    </template>
                  </yq-table-column>
                </yq-table>
              </list-table>
              <form-page v-model:page-number="authResultSearchInfo.pageNumber" v-model:page-size="authResultSearchInfo.pageSize"
                         :total-count="authResultSearchInfo.totalCount" @onLoad="resultQueryList" :show-border="false" :show-shadow="false"/>
            </list-page>
          </template>
        </separator-page>
      </dialog-table>
    </el-dialog>
    <!-- 选择商品,不显示商品列表 -->

  </div>
</template>

<script>
import ListPage from "@/components/h5/layout/ListPage";
import ListTable from "@/components/h5/layout/ListTable.vue";
import FormPage from "@/components/h5/layout/FormPage";
import PageButton from "@/components/h5/button/PageButton";
import FormItems from "@/components/h5/layout/FormItems.vue";
import FormItem from "@/components/h5/layout/FormItem.vue";
import {useRoute, useRouter} from "vue-router";
import Util from "@/util/util";
import SearchCondition from "@/components/h5/layout/SearchCondition.vue";
import Dictionary from "@/components/h5/data/Dictionary.vue";
import TableButton from "@/components/h5/button/TableButton.vue";
import ImageShow from "@/components/h5/image/ImageShow.vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
import TableButtonGroup from "@/components/h5/button/TableButtonGroup.vue";
import ProductSelect from "@/components/h5/product/ProductSelect.vue";
import commonApi from "@/api/commonApi";
import productGrantApi from "@/api/normal/product/productGrantApi";
import YqIcon from "@/components/YqIcon.vue";
import DialogTable from "@/components/h5/layout/DialogTable.vue";
import SeparatorPage from "@/components/h5/layout/SeparatorPage.vue";
import TreeDictionary from "@/components/h5/data/TreeDictionary.vue";
import EmployeeSelect from "@/components/h5/data/EmployeeSelect.vue";
import employeeApi from "@/api/normal/sys/employeeApi";
export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "",
  components: {
    EmployeeSelect,
    TreeDictionary, SeparatorPage,
    YqIcon,
    TableButtonGroup, YqTableColumn, ImageShow, TableButton, Dictionary,
    SearchCondition, ProductSelect, DialogTable,
    PageButton, ListPage, ListTable, FormPage, FormItems, FormItem
  },
  data() {
    return {
      dataDetail: {},
      dataList: [],
      searchInfo: {pageNumber: 1},
      unitList: [],
      showAdd: false, // 添加授权
      currentData: {}, // 当前修改的数据
      authResultShow: false, // 显示授权结果
      authResultList: [], // 授权结果
      authResultSearchInfo: {pageNumber: 1},
      productCategory: [], // 商品分类
      productCategoryAll: [], // 商品分类（包含全部）
      targetEmployeeId: "",
      queryAllProductApi: employeeApi.queryProductList
    };
  },
  beforeRouteLeave(to, from, next) {
    // 将当前页面数据进行缓存
    Util.cachePageData(this, to, from);
    next();
  },
  created() {
    this.targetEmployeeId = this.route.query.id;
    // 商品单位
    commonApi.queryUniqueDictionaryList("PRODUCT_UNIT").then(list => this.unitList = list);
    // 商品分类
    commonApi.queryDictionaryTree("PRODUCT_CATEGORY").then(list => {
      this.productCategory = list;
      this.productCategoryAll = [{dictCode: "", dictName: "全部", children: list}];
    })
    this.resetSearch();
  },
  methods: {
    init() {

    },
    resetSearch() {
      this.searchInfo.pageNumber = 1;
      this.searchInfo.staffId = this.targetEmployeeId;
      this.queryList();
    },
    // 查询授权配置列表
    async queryList() {
      const {records, totalCount} = await productGrantApi.queryList(this.searchInfo);
      this.dataList = records || [];
      this.searchInfo.totalCount = totalCount;
      // 回填授权数据名称与授权方式名称
      for (const row of this.dataList) {
        row.authTypeName = row.authType === 2 ? "按分类" : "单个商品";
      }
    },
    // 格式化时间
    formatTime(time) {
      if (!time) return "";
      return String(time).replace("T", " ").substring(0, 16);
    },
    // 删除授权（取消授权）
    async toDelete(row) {
      await productGrantApi.cancel(row.id);
      this.$message.success("已取消授权");
      this.resetSearch();
    },
    // 删除授权结果
    async toDeleteResult(row) {
      await productGrantApi.deleteResult(row.id);
      this.$message.success("已删除该授权结果");
      this.resultResetSearch();
    },
    // 查询授权结果
    resultResetSearch() {
      this.authResultSearchInfo.pageNumber = 1;
      this.resultQueryList();
    },
    // 查询授权结果列表
    async resultQueryList() {
      const {records, totalCount} = await productGrantApi.queryGrantResult({
        ...this.authResultSearchInfo,
        staffId: this.targetEmployeeId,
      });
      this.authResultList = records || [];
      this.authResultSearchInfo.totalCount = totalCount;
      // 授权方式名称
      this.authResultList.forEach(row => row.authTypeName = row.authType === 2 ? "按分类" : "单个商品");
    },
    toAddAuth() {
      this.currentData = {
        authType: 1,
        categoryIdList: [],
        productList: [],
        productListIds: "",
        staffId: this.targetEmployeeId,
      };
      this.showAdd = true;
    },
    toShowResult() {
      this.authResultShow = true;
      this.resultResetSearch();
    },
    selectProduct2Current(val) {
      this.currentData.productList = val? val.split(",") : [];
    },
    // 保存授权
    async saveAuth() {
      if (!this.currentData.authType) {
        this.$message.error("请选择授权方式");
        return;
      }
      let detailList = [];
      let config = {authType: this.currentData.authType, staffId: this.targetEmployeeId};
      if (this.currentData.authType === 1) { // 按单个商品授权
        const products = this.currentData.productList || [];
        if (products.length === 0) {
          this.$message.error("请选择授权商品");
          return;
        }
        for (let i = 0; i < products.length; i++) {
          detailList.push({...config, productId: products[i]})
        }
      } else if (this.currentData.authType === 2) { // 按分类授权
        const categoryIds = this.currentData.categoryIdList || [];
        if (categoryIds.length === 0) {
          this.$message.error("请选择商品分类");
          return;
        }
        // categoryIdList 是字典树节点的 dictCode 数组
        for (let i = 0; i < categoryIds.length; i++) {
          detailList.push({...config, categoryId: categoryIds[i]})
        }
      }
      try {
        await productGrantApi.save(detailList);
        this.$message.success("授权成功");
        this.showAdd = false;
        this.resetSearch();
      } catch (e) {
        // 保留弹框，便于用户修正
      }
    },
    clickCategory(data) {
      this.authResultSearchInfo.categoryId = data.dictCode;
      this.resultResetSearch();
    }
  }
};
</script>

<style lang="scss" scoped>
.grant-tip {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: var(--yq-font-color-tips, #909399);
  background: var(--el-color-primary-light-9, #ecf5ff);
  border-radius: 4px;
  padding: 8px 12px;
  margin-bottom: 14px;
  line-height: 1.5;
}
.grant-select-wrap {
  width: 100%;
  box-sizing: border-box;
  .grant-tag {
    margin-right: 8px;
    margin-bottom: 8px;
  }
  .grant-add-btn {
    text-align: center;
    color: var(--el-color-primary);
    cursor: pointer;
    font-size: 13px;
    padding: 4px 8px;
    border: 1px dashed var(--el-border-color);
    border-radius: 4px;
    &:hover {
      border-color: var(--el-color-primary);
      background: var(--el-color-primary-light-9);
    }
  }
  .grant-count {
    margin-top: 8px;
    font-size: 12px;
    color: var(--yq-font-color-desc, #909399);
  }
}
</style>